export const GET_DEFAULT_PROFILES = 'GET_DEFAULT_PROFILES';
export const SET_DEFAULT_PROFILES = 'SET_DEFAULT_PROFILES';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_DEFAULT_PROFILE = 'SET_DEFAULT_PROFILE';
export const ADD_DEFAULT_PROFILE = 'ADD_DEFAULT_PROFILE';
export const EMPTY_DEFAULT_PROFILE = 'EMPTY_DEFAULT_PROFILE';
export const DELETE_DEFAULT_PROFILE = 'DELETE_DEFAULT_PROFILE';
export const EDIT_DEFAULT_PROFILE = 'EDIT_DEFAULT_PROFILE';
export const UPDATE_DEFAULT_PROFILE = 'UPDATE_DEFAULT_PROFILE';
export const SET_DEFAULT_PROFILE_FILTER = 'SET_DEFAULT_PROFILE_FILTER';
export const GET_DEFAULT_PROFILES_LIST = 'GET_DEFAULT_PROFILES_LIST';
export const SET_DEFAULT_PROFILES_LIST = 'SET_DEFAULT_PROFILES_LIST';